<script lang="ts" setup>
import { shallowReactive } from 'vue';
import { openLocalMap } from '@base/@core/utils/openLocalMap'

const companyName = '湖南和贵网络科技有限公司'
const connectSitemap = shallowReactive({
  logo: '/images/pages/logo_gray.png',
  companyName: companyName,
  connectType: {
    icon: '/images/pages/home/Call@2x.png',
    // content: '13873160171', // 赵
    // content: '16680534973', // 刘
    content: '13874895733', // 李
    label: '联系方式：'
  },
  connnctMail: {
    icon: '/images/pages/home/Message@2x.png',
    label: '公司邮箱：',
    content: 'service@hnhegui.com'
  },
  address: {
    icon: '/images/pages/home/Location@2x.png',
    label: '公司地址：',
    content: '公司地址：',
    Changsha: '湖南省长沙市高新开发区岳麓大道芯城科技园一期1栋1701 ',
    Shenzheng: '深圳市南山区粤海街道科苑路8号讯美科技广场2号楼1903'
  }
})

const mobileAddress = {
  // GCJ02(高德/腾讯坐标系)112.87555, 28.229282东经E：112°52′31.98″    北纬N：28°13′45.42″BD09(百度坐标系)112.882127522733, 28.23505439752048东经E：112°52′55.66″    北纬N：28°14′6.20″
  changsha: {
    gcj02: [112.87555, 28.229282],
    bd09: [112.882127522733, 28.23505439752048],
    title: "湖南和贵网络科技有限公司"
  },
  // GCJ02(高德/腾讯坐标系)113.947498, 22.544732东经E：113°56′50.99″    北纬N：22°32′41.04″BD09(百度坐标系)113.95404642160504, 22.550413381885495东经E：113°57′14.57″    北纬N：22°33′1.49″
  shengzheng: {
    gcj02: [113.947498, 22.544732],
    bd09: [113.95404642160504, 22.550413381885495],
    title: "深圳和贵网络科技有限公司"
  }
}
const productSitemap = shallowReactive([
  {
    categoryName: '热门产品',
    list: [
      {
        name: '飞马外勤',
        url: '/products/feima'
      },
      {
        name: 'DMS经销商渠道管理平台',
        url: '/products/dms'
      },
      {
        name: '门店收银系统',
        url: '/products/store-cashier'
      },
      {
        name: '即时榔',
        url: '/products/jsl'
      },
      {
        name: '即时鸟',
        url: '/products/jsn'
      }
    ]
  },
  {
    categoryName: '解决方案',
    list: [
      {
        name: '和贵惠供',
        url: '/products/hghg'
      },
      {
        name: '和成天下会员中心',
        url: '/products/hctx-customer-center'
      }
    ]
  },
  {
    categoryName: '关于我们',
    list: [
      {
        name: '公司介绍',
        url: '/about-us#company-intro'
      },
      {
        name: '企业荣誉',
        url: '/about-us#company-honors'
      }
    ]
  }
])
</script>

<template>
  <section tag="section" class="page-site-map flex text-left max-ml:text-center">
    <!-- 拨号（点击会唤起系统拨号器） -->
    <!-- 发邮件（可带 subject/body/cc/bcc） -->
    <!-- <a href="mailto:someone@example.com?subject=你好&body=这是邮件正文">发邮件</a> -->
    <PageContentCenter class="flex py-10">
      <ul class="w-[40%] max-lg:pl-4 relative  max-ml:w-100%  max-ml:self-center max-ml:flex max-ml:flex-col">
        <li class="max-ml:hidden">
          <Pic class="site-map-logo w-25 mb-4" :src="connectSitemap.logo" alt="湖南和贵网络科技有限公司"
            :title="connectSitemap.companyName" />
        </li>
        <li>
          <h5 class="text-[#b9bfc7] text-5 mb-3rem max-ml:text-center max-ml:mb-2rem!">{{ connectSitemap.companyName }}
          </h5>
        </li>
        <li class="text-3.5 mb-5 flex max-ml:hidden">
          <Pic class="w-1.5rem h-1.5rem mr-0.86rem relative flex-shrink-0" :src="connectSitemap.connectType.icon"></Pic>
          <!-- <span>{{ connectSitemap.connectType.content }}</span> -->
          <label class="w-5rem flex-shrink-0" for="">{{ connectSitemap.connectType.label }}</label>
          <a :href="`tel:${connectSitemap.connectType.content}`">{{ connectSitemap.connectType.content }}</a>
        </li>
        <li class="text-3.5 mb-5 flex max-ml:relative max-ml:flex max-ml:self-center">
          <Pic class="w-1.5rem h-1.5rem mr-0.86rem relative flex-shrink-0 max-ml:mr-0.5rem"
            :src="connectSitemap.connnctMail.icon"></Pic>
          <label class="w-5rem flex-shrink-0 max-ml:hidden" for="">{{ connectSitemap.connnctMail.label }}</label>
          <!-- <span>{{ connectSitemap.connnctMail.content }}</span> -->
          <a :href="`mailto:service@hnhegui.com?subject=你好: 和贵&body=${companyName}，祝贵公司事业长虹！`">{{
            connectSitemap.connnctMail.content }}</a>
        </li>
        <li
          class="text-3.5 mb-1 flex max-ml:relative max-ml:flex max-ml:text-center  max-ml:max-w-90% max-ml:self-center">
          <Pic class="w-1.5rem h-1.5rem mr-0.86rem relative flex-shrink-0 max-ml:mr-0rem"
            :src="connectSitemap.address.icon"></Pic>
          <div class="flex">
            <label class="w-5rem flex-shrink-0 max-ml:hidden" for="">{{ connectSitemap.address.label }}</label>
            <p class="leading-1.5rem">
              <span @click="() => openLocalMap(mobileAddress.changsha)">{{ connectSitemap.address.Changsha }}</span>
              <!-- <a class="text-#fff" @click="() => openLocalMap(mobileAddress.changsha)" href="geo:28.229282,112.87555">{{
                connectSitemap.address.Changsha }}</a> -->
              <br />
              <span @click="() => openLocalMap(mobileAddress.shengzheng)">{{ connectSitemap.address.Shenzheng }}</span>
            </p>
          </div>
        </li>
      </ul>

      <div class="w-[60%] flex justify-evenly max-ml:hidden">
        <ul v-for="categoryItem of productSitemap" :key="categoryItem.categoryName">
          <li>
            <h6 class="text-[#fff] text-5 mb-7.5">{{ categoryItem.categoryName }}</h6>
          </li>
          <li class="mb-3.5 text-3.5" v-for="productItem of categoryItem.list" :key="productItem.name">
            <NuxtLink class="hover:text-#fff" :href="productItem.url" external>{{ productItem.name }}</NuxtLink>
          </li>
        </ul>
      </div>
    </PageContentCenter>
  </section>

  <section tag="phone"
    class=" page-site-map-mobile-phone bg-white text-center items-center px-1.125rem fixed flex justify-around w-100vw h-4.5rem bottom-0 left-0 right-0 hidden! max-ml:flex!">
    <a :href="`tel:${connectSitemap.connectType.content}`" class="flex items-center flex-col block">
      <Pic class="w-1.5rem h-1.5rem" src="/images/mobile/headphones.png"></Pic>
      <span class="  inline-block text-0.625rem text-#616671">预约顾问</span>
    </a>
    <a :href="`tel:${connectSitemap.connectType.content}`" class="flex items-center flex-col block">
      <Pic class="w-1.5rem h-1.5rem" src="/images/mobile/PhoneCall.png"></Pic>
      <span class="  inline-block text-0.625rem text-#616671">联系方式</span>
    </a>
    <span
      class="text-#fff  bg-primary w-11rem h-2.8rem leading-2.8rem rounded-1.4rem flex items-center justify-center text-center">
      <a href="/contact-us/">联系我们</a>
    </span>
  </section>
</template>

<style scoped lang="scss">
.page-site-map {
  width: 100vw;
  max-width: $page-max-width;
  min-height: 20rem;
  background-color: #1b2838;
  color: #b9bfc7;

  .site-map-logo {
    filter: brightness(0) invert(1);
  }
}
</style>
